<template>
  <div class="mapContainer">
    <div id="d3mapSelector"></div>
  </div>
</template>

<script>
import * as d3 from 'd3'

export default {
  data: () => ({
    width: null,
    height: null,
    projection: null,
    path: null,
    zoom: null
  }),
  methods: {
    selectCountry(idCountry) {
      d3.select('#' + idCountry).classed('selected', true)
    },
    unselectCountry(idCountry) {
      d3.select('#' + idCountry).classed('selected', false)
    },
    processWorldD: function(world, svg) {
      let self = this
      svg
        .selectAll('path')
        .data(world.features)
        .enter()
        .append('path')
        .attr('d', self.path)
        .attr('id', function(d) {
          return d.properties.title
        })
        .on('mouseover', function(d) {
          d3.select(this).classed('active', true)
          return d3.select('#mapTooltip').style('visibility', 'visible')
        })
        .on('mouseout', function(d) {
          d3.select(this).classed('active', false)
          return d3.select('#mapTooltip').style('visibility', 'hidden')
        })
        .on('mousemove', function(d) {
          return d3
            .select('#mapTooltip')
            .style('top', d3.event.pageY - 35 + 'px')
            .style('left', d3.event.pageX + 10 + 'px')
            .text(self.$t(d.properties.title))
        })
        .on('click', function(d) {
          let isSelected = d3.select(this).classed('selected')
          if (isSelected) {
            self.$emit('mapUnclicked', {
              id: d.properties.title,
              title: self.$t(d.properties.title)
            })
          } else {
            self.$emit('mapClicked', {
              id: d.properties.title,
              title: self.$t(d.properties.title)
            })
          }
        })
    },
    processSmall: function(world, svg) {
      let self = this
      svg
        .selectAll('circle')
        .data(world.features)
        .enter()
        .append('circle')
        .attr('r', 2)
        .attr('cx', function(d) {
          return self.projection([d.properties.x, d.properties.y])[0]
        })
        .attr('cy', function(d) {
          return self.projection([d.properties.x, d.properties.y])[1]
        })
        .attr('id', function(d) {
          return d.properties.id
        })
        .on('mouseover', function() {
          d3.select(this).classed('active', true)
          return d3.select('#mapTooltip').style('visibility', 'visible')
        })
        .on('mousemove', function(d) {
          return d3
            .select('#mapTooltip')
            .style('top', d3.event.pageY - 15 + 'px')
            .style('left', d3.event.pageX + 10 + 'px')
            .text(self.$t(d.properties.id))
        })
        .on('mouseout', function() {
          d3.select(this).classed('active', false)
          return d3.select('#mapTooltip').style('visibility', 'hidden')
        })
        .on('click', function(d) {
          let isSelected = d3.select(this).classed('selected')
          if (isSelected) {
            self.$emit('mapUnclicked', {
              id: d.properties.id,
              title: self.$t(d.properties.id)
            })
          } else {
            self.$emit('mapClicked', {
              id: d.properties.id,
              title: self.$t(d.properties.id)
            })
          }
        })
    }
  },
  created() {},
  mounted() {
    document.body.style.overflow = 'hidden'
    let self = this
    let totalWidth = window.innerWidth
    let totalHeight = window.innerHeight
    self.width = totalWidth
    self.height = totalHeight
    self.projection = d3.geo
      .mercator()
      .scale((this.width + 1) / 2 / Math.PI)
      .translate([this.width / 2, this.height / 2])
      .precision(0.1)
    this.path = d3.geo.path().projection(self.projection)

    let svg = d3
      .select('#d3mapSelector')
      .append('svg')
      .attr('width', self.width + 'px')
      .attr('height', self.height + 'px')
      .call(
        d3.behavior.zoom().on('zoom', function() {
          svg.attr(
            'transform',
            'translate(' +
              d3.event.translate +
              ')' +
              ' scale(' +
              d3.event.scale +
              ')'
          )
        })
      )
      .append('g')
    d3.select('body')
      .append('div')
      .attr('id', 'mapTooltip')
      .style('position', 'absolute')
      .style('z-index', '10')
      .style('visibility', 'hidden')

    d3.json('/geo_data/bigCountries.geo.json', function(error, world) {
      if (error) return console.error(error)
      self.processWorldD(world, svg)
      d3.json('/geo_data/smallCountries.geo.json', function(error, world) {
        if (error) return console.error(error)
        self.processSmall(world, svg)
      })
    })
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto'
    d3.select('#mapTooltip').style('visibility', 'hidden');
  }
}
</script>

<style lang="scss">
@import '~@/scss/_mixins.scss';

.mapContainer {
  background-color: white;
}
/*
#d3mapSelector {
  @include xs {
    display: none;
    .mapContainer {
      background-color: transparent;
    }
  }

  @include sm {
    display: none;
    .mapContainer {
      background-color: transparent;
    }
  }

  @include md {
    display: none;
    .mapContainer {
      background-color: transparent;
    }
  }
}*/
</style>

<style lang="scss">
#d3mapSelector {
  touch-action: none;
}
#d3mapSelector svg {

}
#mapTooltip {
  background: white;
  padding: 5px 10px;
  border: solid 2px var(--rosa-eco);
  border-radius: 10px 10px 10px 0;
  box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.5);
}

#d3mapSelector path {
  fill: #8cc63f;
  stroke: white;
  stroke-width: .2px;
  transition: .3s;

}

#d3mapSelector circle {
  fill: var(--verde-light-eco);
  stroke: var(--verde-light-eco);
  r: calc(1px);
}

#d3mapSelector path.active {
  fill: #a7d766;
  transition: .3s;
}

#d3mapSelector path.selected,
#d3mapSelector circle.selected {
  fill: var(--rosa-eco);
  stroke: #c03a7d;
  transition: .3s;

}

#d3mapSelector circle.active {
  fill: var(--verde-light-eco);
}
</style>
